'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = orders;

var _actions = require('../helpers/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = [];

function orders() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'ORDERS':
      return state;
    case 'ORDERS_SUCCESS':
      return (0, _extends3.default)({}, state, action.result.orders);
    case 'ORDERS_FAILURE':
      return (0, _extends3.default)({}, state, { error: (0, _actions.serializableError)(action.error) });
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/reducers/orders.js
// module id = 2534
// module chunks = 0